<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/v2WJ4E/tc-custom/cover.jpg?1684571222199?1719603450184" alt="This image is the cover for the book Graffiti"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Graffiti
      </h1>
      <p class="bookDescription body article font2">
        <p>To create this inaugural anthology from artist collective POC United, the editors of Graffiti gave the contributors a special challenge: to write in a way that centers neither "whiteness" nor "anti-whiteness” and that is not limited by their struggle, their oppression, or how their characters will be received by the white imagination. The results are joyous and mind-expanding. Through poetry, short stories, and essays, the works in Graffiti expose lives that move in unexpected ways, rendering characters who don’t fit the cultural tropes we cling to. Graffiti shows what writers of color do when they are invited to scribble, scrawl, romanticize, and speculate without being politicized or exoticized.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Pallavi Dhawan, Devi S. Laskar, Tamika Thompson
      </h2>
      
      <p class="authorDescription body article">Pallavi Dhawan is a writer and lawyer living in Los Angeles. She received her bachelor of arts in political science and international relations as well as her juris doctor from University of California, Los Angeles. She is an alumna of VONA/Voices, the Community of Writers at Sq. Valley, and Hedgebrook. She is working on her first novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Aunt Lute Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?168305ee